import { useEffect, useRef } from 'react'

const CustomCursor = () => {
  const dotRef = useRef(null)
  const ringRef = useRef(null)
  const pos = useRef({ x: -100, y: -100 })
  const trail = useRef({ x: -100, y: -100 })

  useEffect(() => {
    const dot = dotRef.current
    const ring = ringRef.current
    if (!dot || !ring) return

    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY }
    }

    const onOver = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select')) {
        ring.style.width = '54px'
        ring.style.height = '54px'
        ring.style.borderColor = '#facc15'
        ring.style.boxShadow = '0 0 18px rgba(250,204,21,0.7), 0 0 40px rgba(250,204,21,0.25)'
        ring.style.background = 'rgba(250,204,21,0.06)'
        dot.style.width = '5px'
        dot.style.height = '5px'
        dot.style.boxShadow = '0 0 14px rgba(255,255,255,0.9)'
        dot.style.background = '#fff'
      }
    }

    const onOut = (e) => {
      if (!e.relatedTarget || !e.relatedTarget.closest('a, button, [role="button"], input, textarea, select')) {
        ring.style.width = '30px'
        ring.style.height = '30px'
        ring.style.borderColor = 'rgba(250,204,21,0.45)'
        ring.style.boxShadow = 'none'
        ring.style.background = 'transparent'
        dot.style.width = '7px'
        dot.style.height = '7px'
        dot.style.boxShadow = '0 0 10px rgba(250,204,21,0.95)'
        dot.style.background = '#facc15'
      }
    }

    const onClick = () => {
      ring.style.transform = 'translate(-50%, -50%) scale(1.6)'
      ring.style.opacity = '0'
      setTimeout(() => {
        ring.style.transition = 'width 0.2s ease, height 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease'
        ring.style.transform = 'translate(-50%, -50%) scale(1)'
        ring.style.opacity = '1'
      }, 200)
    }

    let raf
    const animate = () => {
      trail.current.x += (pos.current.x - trail.current.x) * 0.11
      trail.current.y += (pos.current.y - trail.current.y) * 0.11
      ring.style.left = trail.current.x + 'px'
      ring.style.top = trail.current.y + 'px'
      dot.style.left = pos.current.x + 'px'
      dot.style.top = pos.current.y + 'px'
      raf = requestAnimationFrame(animate)
    }
    raf = requestAnimationFrame(animate)

    window.addEventListener('mousemove', onMove)
    document.addEventListener('mouseover', onOver)
    document.addEventListener('mouseout', onOut)
    document.addEventListener('click', onClick)

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseover', onOver)
      document.removeEventListener('mouseout', onOut)
      document.removeEventListener('click', onClick)
    }
  }, [])

  return (
    <>
      {/* lagging ring */}
      <div
        ref={ringRef}
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          border: '1.5px solid rgba(250,204,21,0.45)',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 99998,
          transition: 'width 0.22s ease, height 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease, background 0.22s ease, opacity 0.2s ease',
        }}
      />
      {/* sharp dot */}
      <div
        ref={dotRef}
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '7px',
          height: '7px',
          borderRadius: '50%',
          background: '#facc15',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          zIndex: 99999,
          boxShadow: '0 0 10px rgba(250,204,21,0.95)',
          transition: 'width 0.12s ease, height 0.12s ease, background 0.12s ease, box-shadow 0.12s ease',
        }}
      />
    </>
  )
}

export default CustomCursor
